import Vue from 'vue'
import FullCalendar from '@fullcalendar/vue'

Vue.component('full-calendar', FullCalendar)
